import { View, Text } from "react-native";
import React from "react";

const PaymentReceipt = () => {
  return (
    <View>
      <Text>PaymentReceipt</Text>
    </View>
  );
};

export default PaymentReceipt;
